module.exports = __webpack_public_path__ + "img/banner_img1.53bf9515.png";